import { render, staticRenderFns } from "./campusDetail.vue?vue&type=template&id=debcf394&scoped=true"
import script from "./campusDetail.vue?vue&type=script&lang=js"
export * from "./campusDetail.vue?vue&type=script&lang=js"
import style0 from "./campusDetail.vue?vue&type=style&index=0&id=debcf394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debcf394",
  null
  
)

export default component.exports